import TransactionsIcon from '@mui/icons-material/MultilineChartSharp';
import AllTransactionsList from './List';

const AllTransactions = {
  icon: TransactionsIcon,
  name: `transactions/all`,
  list: AllTransactionsList,
};

export default AllTransactions;